<template>
  <img v-if="imageFlag"
    v-b-tooltip.html="{
      variant: 'secondary',
      animation: true,
      customClass: 'custom-class-name',
      trigger: 'hover',
      placement: 'top'
    }"
    :title="url ? `<a style='color: white !important; text-decoration: underline !important;' href=${url}>${title}</a>` : title"
    src="../../assets/images/help_outline_gray_24dp.svg"
    alt="Question mark"
    class="question_mark"
  />
  <div v-frag v-else>
    <span ref="labelRef" :id="id" :class="className" @mouseover="showTooltip">
      {{ title }}
    </span>
    <b-tooltip v-if="isShowTooltip" :target="id" v-bind="tooltipAttributes">
      {{ title }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    imageFlag: {
      type: Boolean,
      default: true
    },
    className: {
      type: String
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    placement: {
      type: String,
      default: 'top'
    },
    url: {
      type: String,
      default: null
    },
    title: String
  },
  data() {
    return {
      tooltipAttributes: {
        variant: 'secondary',
        animation: true,
        customClass: 'custom-class-name',
        triggers: this.trigger,
        placement: this.placement,
        title: this.title
      },
      isShowTooltip: false
    }
  },
  methods: {
    showTooltip() {
      const elementLabelId = document.getElementById(this.id)
      if (elementLabelId) {
        this.isShowTooltip = elementLabelId.scrollWidth > elementLabelId.clientWidth
        return this.isShowTooltip
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .custom-class-name {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/TooltipComponent.vue